<template>
  <div>
    <div class="h6 mb-3">
      Parlez nous de vous : votre style de vie, situation familiale, conjoint,
      enfants, vos revenus principaux et complémentaires
    </div>

    <v-layout row>
      <v-flex :class="{ xs7: !isNew, xs12: isNew }">
        <v-textarea
          v-model="instance.aboutYou"
          label="Votre situation personnelle"
          data-vv-name="aboutYou"
          :error-messages="errors.collect('aboutYou')"
        >
        </v-textarea>
      </v-flex>
      <v-flex
        xs5
        class="mt-2 ml-1"
        style="color: grey; font-size: .8rem"
        v-if="!isNew"
      >
        <h4>Notre feedback</h4>
        <p>
          {{
            instance.aboutYouAdmin ||
              "Nous n'avons rien renseigné pour l'instant"
          }}
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "ProjectSituation",
  props: ["value", "project", "isNew"],
  mounted() {
    if (this.project != null) {
      const { aboutYou, aboutYouAdmin } = this.project;
      this.instance = {
        aboutYou,
        aboutYouAdmin
      };
    }
    this.send();
  },
  data() {
    return {
      instance: {
        aboutYou: ""
      }
    };
  },
  methods: {
    async send() {
      if (!(await this.$validator.validate())) {
        this.$emit("input", null);
        return;
      }
      this.$emit("input", { ...this.instance });
    }
  },
  watch: {
    instance: {
      deep: true,
      async handler() {
        return this.send();
      }
    }
  }
};
</script>

<style scoped></style>
